import { render, staticRenderFns } from "./BanLinkUpload.vue?vue&type=template&id=410ccd20&"
import script from "./BanLinkUpload.vue?vue&type=script&lang=js&"
export * from "./BanLinkUpload.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports